import React, { Component } from "react";

class SkipToTopLink extends Component {
  constructor() {
    super();

    this.state = {
      focus: false,
    };
    this.handleSkipLinkChildOnFocus = this.handleSkipLinkChildOnFocus.bind(this);
    this.handleSkipLinkChildOnBlur = this.handleSkipLinkChildOnBlur.bind(this);
    this.handleEnterKeyPress = this.handleEnterKeyPress.bind(this);
  }
  /** Detects when focus in on the SkipToTop Button */
  handleSkipLinkChildOnFocus(event) {
    if (event.type === "focus") {
      if (!this.state.focus) {
        this.setState({ focus: true });
      }
    }
  }
  /** Detects when the SkipToTop Button has lost focus */
  handleSkipLinkChildOnBlur(event) {
    if (event.type === "blur") {
      if (this.state.focus) {
        this.setState({ focus: false });
      }
    }
  }
  /** Will scroll the browser to the top of the page when the enter key is pressed. */
  handleEnterKeyPress(event) {
    const keyboardEvent = event.which || event.code;
    if (keyboardEvent === 13 || keyboardEvent === 'Enter' || keyboardEvent === 32 || keyboardEvent === 'Space') {
      window.scroll({top: 0, left: 0});
      
    }
  }

  render() {
    return (
      <div id="pageTopContainer" className="row">
        <a
          className={!this.state.focus ? "skplnk-focus" : "skplnk-focus active"}
          aria-label={"Go to Page Top"}
          href={'#pageTop'}
          sktarget={'#pageTop'}
          onFocus={(event) => this.handleSkipLinkChildOnFocus(event)}
          onBlur={(event) => this.handleSkipLinkChildOnBlur(event)}
          // onKeyDown={(event) => this.handleEnterKeyPress(event)}
        >
          {"Back to Top"}
        </a>
      </div>
    );
  }
}

export default SkipToTopLink;